import React from 'react';
import { useToast } from '../context/ToastContext';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50 flex flex-col gap-2 w-full max-w-sm px-4 md:bottom-10 md:left-auto md:right-10 md:transform-none">
      {toasts.map(toast => {
        let bgColor = 'bg-blue-600';
        let Icon = AlertCircle;

        if (toast.type === 'success') {
          bgColor = 'bg-green-600';
          Icon = CheckCircle;
        } else if (toast.type === 'error') {
          bgColor = 'bg-red-600';
          Icon = XCircle;
        }

        return (
          <div key={toast.id} className={`${bgColor} text-white px-4 py-3 rounded-lg shadow-lg flex items-center justify-between animate-fade-in-up`}>
            <div className="flex items-center gap-3">
              <Icon className="w-5 h-5 shrink-0" />
              <p className="text-sm font-medium">{toast.message}</p>
            </div>
            <button onClick={() => removeToast(toast.id)} className="ml-4 hover:bg-white/20 p-1 rounded-full transition-colors shrink-0">
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
